/* eslint new-cap: ["error", { "capIsNew": false }]*/
import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import RefPicker from '../../dict/simple/select/DictPicker.jsx';
import {
  FormControl,
  Button,
  Checkbox,
} from '../../form/FormControls.jsx';
import { updateUser as updateUserAction, loadUsers, createUser as createUserAction }
  from './user.store';
import { MainComponentBox, FormGroupWValidation as FormGroup,
  createFormData, goBack } from '../../../util/util.jsx';
import { RoleElement } from './RoleElement';
import './users.css';
import { getUsersListWrapper } from './UserWrapper.js';
import RequiredFormControl from '../../form/RequiredFormControl.jsx';
import { putError as putErrorAction, removeError as removeErrorAction }
  from '../../../store/error.store';
import { List, Map } from 'immutable';
import { resolvePasswordValidationError } from './Profile.jsx';

const ReactDOM = require('react-dom');
// I'm kinda relying on the fact that the store branch with
// user info is loaded already... shouldn't do this tho

const mapDispatchToProps = (dispatch, props) => ({
  updateUser(userDto) {
    updateUserAction(dispatch, userDto);
  },
  createUser(userDto) {
    createUserAction(dispatch, userDto);
  },

  loadUsersFromServer() {
    loadUsers(dispatch);
  },
  cancel() {
    goBack(props.location.pathname);
  },

  putError(error) {
    putErrorAction(dispatch, error);
  },

  removeError(key) {
    removeErrorAction(dispatch, key);
  },

});

class Edit extends React.Component {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleRolesChange = this.handleRolesChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.onRegionChange = this.onRegionChange.bind(this);
    this.state = ({
      submitDisable: false,
      password: '',
      roles: [],
    });
  }

  componentWillMount() {
    getUsersListWrapper();
    this.setNewState(this.props);
  }
  componentWillReceiveProps(props) {
    getUsersListWrapper();
    this.setNewState(props);
  }

  componentDidUpdate() {
    const node = ReactDOM.findDOMNode(this.refs.password);
    if (node) {
      node.focus();
    }
  }
  onRegionChange(event) {
    this.setState({ origin: event ? event.value : null });
  }

  onSubmit(event) {
    event.preventDefault();
    const formData = (createFormData('userForm'));
    if (this.state.origin !== undefined) {
      formData.origin = this.state.origin;
    }
    formData.id = formData.id === '' ? undefined : formData.id;
    if (formData && (formData.password == null || formData.password == '')) {
      delete formData.password;
    }
    if (!formData.origin) {
      formData.origin = null;
    }
    if (this.state.roles) {
      formData.roles = this.state.roles.map(r => (typeof r == 'object' ? r.value : r));
    }
    if (this.props.params.userId && this.props.params.userId !== 'new') {
      this.props.updateUser(formData);
    } else {
      this.props.createUser(formData);
    }
  }

  onCancel() {
    this.props.cancel();
  }

  setNewState(props) {
    if (props.user) {
      const roles = props.user.get('roles') || new List();
      this.setState({ roles: Object.assign(roles.toJS(), this.state.roles) });
    }
  }

  getLabel = () => {
    if (this.props.params.userId && this.props.params.userId !== 'new') {
      return <div className={'edit-reference-header'}>Edit user</div>;
    }
    return <div className={'edit-reference-header'}>New user</div>;
  }

  handlePasswordChange(event) {
    const state = this.state;
    state.password = event.target.value;
    if (!(this.props.params.userId != 'new' && event.target.value.length === 0)
       && event.target.value.length < 10) {
      this.props.putError({ password: 'Password should be 10 characters or longer' });
      state.submitDisable = true;
    } else {
      const passwordError = resolvePasswordValidationError(state.password);
      if (passwordError) {
        this.props.putError({ password: passwordError });
      } else {
        this.props.removeError('password');
      }
      state.submitDisable = false;
    }
    this.setState(state);
  }
  handleRolesChange(event) {
    this.setState({ roles: event });
  }

  render() {
    const external = this.props.isModuleLdapActive && this.props.user.get('password') == 'EXTERNAL';
    const userFound = this.props.user && this.props.user.get('id') != undefined;
    let component;
    if (this.props.params.userId == 'new' || userFound) {
      component = (<div>
        <form id="userForm" onSubmit={this.onSubmit}>
          <input type="password" name="fakepasswordfield" style={{ display: 'none' }} />
          <MainComponentBox>
            <Row className={'reference-edit-panel'} style={{ paddingTop: 45 }}>
              <Col xs={12} md={6} lg={5}>
                {this.getLabel()}
                <Row>
                  <Col sm={6}>
                    <FormGroup id="firstName">
                      <ControlLabel style={{ height: 'auto' }}>First name</ControlLabel>
                      <FormControl
                        name="firstName" type="text"
                        defaultValue={this.props.user.get('firstName')}
                        readOnly={external}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup id="lastName">
                      <ControlLabel style={{ height: 'auto' }}>Last name</ControlLabel>
                      <FormControl
                        name="lastName" type="text"
                        defaultValue={this.props.user.get('lastName')}
                        readOnly={external}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup id="username">
                  <ControlLabel style={{ height: 'auto' }}>User name</ControlLabel>
                  <RequiredFormControl
                    component={FormControl}
                    name="username" type="text"
                    defaultValue={this.props.user.get('username')}
                    readOnly={external} autoComplete="off"
                  />
                </FormGroup>
                <FormGroup id="password">
                  <ControlLabel style={{ height: 'auto' }}>Password</ControlLabel>
                  <RequiredFormControl
                    component={FormControl}
                    disableRequired={this.props.params.userId !== 'new'}
                    name="password" type={external ? 'text' : 'password'}
                    onChange={this.handlePasswordChange} ref="password"
                    className="password-field"
                    placeholder={userFound ? '●●●●●●●●●●' : ''}
                    value={external ? 'EXTERNAL AUTHENTICATION' : this.state.password}
                    readOnly={external} autoComplete="new-password"
                  />
                </FormGroup>
                <FormGroup id="email">
                  <ControlLabel style={{ height: 'auto' }}>Email</ControlLabel>
                  <FormControl
                    name="email" type="text"
                    defaultValue={this.props.user.get('email')}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel style={{ height: 'auto' }}>Roles</ControlLabel>
                  <RoleElement
                    handleRolesChange={this.handleRolesChange}
                    roles={this.state.roles}
                    multi
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel style={{ height: 'auto' }}>Region</ControlLabel>
                  <RefPicker
                    onChangeFunc={this.onRegionChange}
                    dict="origin" name="origin"
                    defaultValue={parseInt(this.state.origin || this.props.user.get('origin'), 10)}
                    disabled={external}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel style={{ height: 'auto' }}>Enabled</ControlLabel>
                  <Checkbox
                    id="enabled" name="enabled"
                    defaultChecked={this.props.user.get('enabled')}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel style={{ height: 'auto' }}>MFA Enabled</ControlLabel>
                  <Checkbox
                    id="mfaEnabled" name="mfaEnabled"
                    defaultChecked={this.props.user.get('mfaEnabled')}
                  />
                </FormGroup>
                <Button
                  type="submit" bsStyle="primary" id="saveUser"
                  disabled={this.state.submitDisable || this.props.saving}
                >
                  Save
                </Button>
                <Button onClick={this.onCancel} id="cancel" bsStyle="gray"> Cancel</Button>
                <FormControl
                  name="id" type="id" style={{ display: 'none' }}
                  defaultValue={this.props.user.get('id')}
                />
              </Col>
            </Row>
          </MainComponentBox>
        </form>
      </div>);
    } else {
      component = <div></div>;
    }
    return component;
  }
}
Edit.propTypes = {
  cancel: React.PropTypes.func,
  user: React.PropTypes.object,
  loadUsersFromServer: React.PropTypes.func,
  params: React.PropTypes.object,
  updateUser: React.PropTypes.func,
  createUser: React.PropTypes.func,
  removeError: React.PropTypes.func,
  putError: React.PropTypes.func,
  isModuleLdapActive: React.PropTypes.bool,
  saving: React.PropTypes.bool,
};
export default connect((state, props) => ({
  saving: state.getIn(['allaround', 'saving'], false),
  user: props.params.userId === 'new' ? new Map() : state.getIn(['data', 'users'], new List)
    .find(usr => usr.get('id') == props.params.userId),
  isModuleLdapActive: state.getIn(['session', 'modules'], '') ? // FF fix
    state.getIn(['session', 'modules'], '').indexOf('ldap') != -1 : false,
}), mapDispatchToProps)(Edit);
